import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const pharmacyExpiredProductsRequestRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/claims/expired_products_request/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import(
    'pages/pharmacy/Cases/ExpiredProductsRequests/PharmacyExpiredProductsRequestPage/PharmacyExpiredProductsRequestPage'
  ).then((d) => d.Route)
);
